import TCFDetails from './TCFDetails'

export default TCFDetails
